import { render, staticRenderFns } from "./groupInfo.vue?vue&type=template&id=64ec944c"
import script from "./groupInfo.vue?vue&type=script&lang=js"
export * from "./groupInfo.vue?vue&type=script&lang=js"
import style0 from "./groupInfo.vue?vue&type=style&index=0&id=64ec944c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports